export default function ($) {

    const $lightbox = $('[data-lightbox]');

    if (!$lightbox.length) return;

    const $slides = $lightbox.find('.lightbox__slide');
    let current = 0;

    function goTo(index) {
        current = (index + $slides.length) % $slides.length;

        $slides.removeClass('is-active').eq(current).addClass('is-active');
        $lightbox.find('[data-lightbox-current]').text(current + 1);
        $lightbox.find('[data-lightbox-goto]').each(function () {
            $(this).toggleClass('is-active', $(this).data('lightbox-goto') === current);
        });
    }

    function open(index) {
        goTo(index);
        $lightbox.removeAttr('hidden');
        $('body').addClass('lightbox-open');
    }

    function close() {
        $lightbox.attr('hidden', true);
        $('body').removeClass('lightbox-open');
    }

    $(document).on('click', '[data-lightbox-open]', function (e) {
        e.preventDefault();
        open(Number($(this).data('lightbox-open')));
    });

    $lightbox.on('click', '[data-lightbox-close]', close);
    $lightbox.on('click', '[data-lightbox-prev]', () => goTo(current - 1));
    $lightbox.on('click', '[data-lightbox-next]', () => goTo(current + 1));
    $lightbox.on('click', '[data-lightbox-goto]', function () {
        goTo(Number($(this).data('lightbox-goto')));
    });

    $(document).on('keydown', function (e) {
        if ($lightbox.attr('hidden')) return;

        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') goTo(current - 1);
        if (e.key === 'ArrowRight') goTo(current + 1);
    });

    let touchX = null;

    $lightbox.on('touchstart', function (e) {
        touchX = e.originalEvent.touches[0].clientX;
    });

    $lightbox.on('touchend', function (e) {
        if (touchX === null) return;

        const delta = e.originalEvent.changedTouches[0].clientX - touchX;

        if (Math.abs(delta) > 50) goTo(current + (delta < 0 ? 1 : -1));

        touchX = null;
    });

}
